import { fCommasAndDecimals } from 'utils/formatNumber'
import { MoneyAmount, MoneyAmountCurrencyCodeEnum } from '@types'

const NANO_CONVERTER = 1000000000

export const convertAmountStringToObject = (amountSet: string): MoneyAmount => {
  const [units, nanos] = amountSet.toString().split('.')
  return {
    units: parseInt(units.replaceAll(',', '')),
    nanos: parseInt(`${nanos || '00'}0000000`),
    currencyCode: MoneyAmountCurrencyCodeEnum.AUD
  }
}

export const getAmountValue = (amount: MoneyAmount) => {
  const nanoValueToDecimal = amount?.nanos ? amount?.nanos / NANO_CONVERTER : 0
  return (amount?.units ? amount?.units : 0) + nanoValueToDecimal
}

export const displayUserReadableAmount = (amount: MoneyAmount) => {
  return fCommasAndDecimals(getAmountValue(amount))
}

export const defineAmountState = (amount: MoneyAmount): string =>
  (amount?.units ?? 0) > 0 ? displayUserReadableAmount(amount) : ''

export const convertAmountStringToValue = (amount: string): number =>
  parseFloat(amount.replaceAll(',', ''))
